// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table Css Starts Here */
.row {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  overflow: hidden;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.row > * {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
  table-layout: auto;
}

thead {
  color: white;
  font-weight: 700;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 13px 10px !important;
}

th,
td {
  padding: 13px 10px !important;
  border: 1px solid #ddd;
  text-align: left;
  color: inherit;
  text-decoration: none;
}

th {
  position: sticky;
  top: 0;
  background-color: #95a2b1;
}

.evaluationTable {
  padding-top: 20px;
}

.right-content {
  flex: 1;
  overflow-y: auto;
  width: auto;
  height: 100%;
}

.table-container {
  width: 100%;
  padding: 0px 20px;
  overflow-x: auto;
}

.table-wrapper {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: auto;
}

.evaluationSubdata-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 250px;
  table-layout: auto;
  width: 0% !important;
}

.menu-header {
  color: #007bff;
}

.noDataFound {
  color: red;
}

.parent td {
  background-color: #f2feff !important;
  font-weight: bold;
  padding: 13px 10px !important;
}

.child td {
  background-color: #eefaff;
  padding: 13px 10px !important;
}

.dtr-title {
  color: #2a62ff;
  display: inline-block;
  font-weight: bold;
  width: 400px !important;
  padding-left: 52px !important;
}

.dtr-title:after {
  content: " : ";
}

.dtr-details {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
  margin: 0 auto;
  border-collapse: collapse;
}

.dtr-details li {
  list-style-type: none;
  margin: 10px 0;
  position: relative;
  padding-left: calc(20px + var(--level, 0) * 40px);
}

/* Table Css Ends Here */
/* Card Css Starts Here */
.card-box {
  position: relative;
  padding: 10px;
  margin: 15px 0;
  border-radius: 7px;
  background-color: #fff;
  transition: transform 0.4s ease, border 0.4s ease;
  cursor: pointer;
  border: 2px solid transparent;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  will-change: transform;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 2px solid var(--dynamic-color);
  color: var(--dynamic-color);
}

.card-box:hover {
  transform: scale(0.96);
  color: #1a1a1a;
  border: 2px solid var(--dynamic-color);
}

.card-box .inner {
  text-align: center;
}

.card-box .inner h5 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  color: var(--dynamic-color);
}

.card-box .inner p {
  font-size: 15px;
  color: #646464;
  margin: 0;
}

.card-box.active .inner p {
  color: white;
}

.card-box.active .inner h5 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  color: white;
}

.card-box.active {
  background-color: var(--dynamic-color);
  color: white;
  border: 2px solid var(--dynamic-color, #007bff);
}

.card-box.reward {
  background: linear-gradient(135deg, #498bef, #a9b9ef);
  border: 2px dashed #021d6d;
  color: black;
  font-weight: 600;
}

.card-box.reward .inner .color-dynamic {
  color: black;
}

.custom-grid-wrapper {
  width: 100%;
  overflow-x: hidden;
}

.custom-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

@media (max-width: 992px) {
  .custom-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 576px) {
  .custom-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
.active-card {
  border: 2px solid var(--dynamic-color);
  background-color: #f0f8ff;
  box-shadow: 0 0 10px var(--dynamic-color);
}

/* Card Css Ends Here */
/* Menu Css Starts Here */
.menu-close-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 0px;
}

.menu-toggle-button {
  width: 35px;
  height: 35px;
  background: #4e8ef7;
  border: 2px solid white;
  border-radius: 5px;
  color: white;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.menu-toggle-button1 {
  width: 40px;
  height: 40px;
  background: white;
  border: 2px solid #4e8ef7;
  border-radius: 5px;
  color: #4e8ef7;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.menu-toggle-button:hover {
  background: #3c7fd9;
  width: 30px;
  height: 30px;
}

.menu-toggle-button1:hover {
  background: white;
  width: 35px;
  height: 35px;
}

.menu-toggle-button i {
  padding: 6px;
}

.menu-toggle-button1 i {
  padding: 6px;
}

.menu-tree {
  width: 3%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: #f9f9f9;
}

.menu-tree1 {
  min-width: 23%;
  max-width: min-content;
  overflow-y: auto;
  position: relative;
  background-color: #f9f9f9;
  padding: 10px;
  border-right: 1px solid #ddd;
  height: auto;
  background: linear-gradient(135deg, #498bef, #a9b9ef);
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
  padding-top: 1px;
}

/* Menu Css Ends Here */
.right-header {
  background: #36f;
  height: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.agentReviewApplndata {
  display: flex;
  background: linear-gradient(135deg, #498bef, #a9b9ef);
  border: 3px solid #f1cf4d;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  height: 45px;
  align-items: center;
  padding: 0 1rem;
  gap: 2rem;
  overflow-x: auto;
}
.agentReviewApplndata .info-pair {
  display: flex;
  min-width: -moz-fit-content;
  min-width: fit-content;
  font-weight: 200;
}
.agentReviewApplndata .info-pair label {
  font-size: 1rem;
  margin-right: 0.4rem;
  white-space: nowrap;
  color: #fff;
}
.agentReviewApplndata .info-pair span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #f1cf4d;
}

.backBtn {
  background: #4e8ef7;
  border: 2px solid #fff;
  border-radius: 5px;
  color: #fff;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.backBtn:hover {
  background-color: #fff;
  color: #4e8ef7;
  border: 2px solid #4e8ef7;
}

.back-button-wrapper {
  flex: 1;
}

/* Ensure full-height layout minus header/footer */
.card {
  height: calc(100vh - 75px);
  display: flex;
  flex-direction: column;
}

.row {
  flex: 1;
  display: flex;
  height: calc(100% - 55px); /* maintain full card height */
  overflow: hidden;
}

/* Left menu and right content same height */
.menu-tree,
.menu-tree1,
.right-content {
  height: calc(100% - 55px);
  max-height: calc(100% - 55px);
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/contest-and-incentive-details/evaluation-details/evaluation-details.component.scss"],"names":[],"mappings":"AAAA,0BAAA;AAEA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,0BAAA;EACA,2BAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,6BAAA;AAAF;;AAGA;;EAEE,6BAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,OAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,oCAAA;EACA,iBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,yBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AAAF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,iDAAA;AACF;;AACA,wBAAA;AAEA,yBAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iDAAA;EACA,eAAA;EACA,6BAAA;EACA,wCAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,2BAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,sCAAA;EACA,YAAA;EACA,+CAAA;AACF;;AACA;EACE,qDAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,WAAA;EACA,kBAAA;AAGF;;AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAGF;;AAAA;EACE;IACE,qCAAA;EAGF;AACF;AAAA;EACE;IACE,qCAAA;EAEF;AACF;AACA;EACE,sCAAA;EACA,yBAAA;EACA,yCAAA;AACF;;AAEA,uBAAA;AAEA,yBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2DAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2DAAA;AAAF;;AAGA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,4BAAA;EACA,YAAA;EACA,qDAAA;EACA,wCAAA;EACA,gBAAA;AAAF;;AAGA,uBAAA;AAEA;EACE,gBAAA;EACA,YAAA;EACA,yCAAA;AADF;;AAIA;EACE,aAAA;EACA,qDAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AADF;AAGE;EACE,aAAA;EACA,2BAAA;EAAA,sBAAA;EACA,gBAAA;AADJ;AAGI;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AADN;AAII;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAFN;;AAyBA;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAtBF;;AAyBA;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;AAtBF;;AAyBA;EACE,OAAA;AAtBF;;AAyBA,kDAAA;AACA;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,OAAA;EACA,aAAA;EACA,yBAAA,EAAA,8BAAA;EACA,gBAAA;AAtBF;;AAyBA,4CAAA;AACA;;;EAGE,yBAAA;EACA,6BAAA;EACA,gBAAA;AAtBF","sourcesContent":["/* Table Css Starts Here */\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  height: 100%;\n  overflow: hidden;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.row > * {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n  table-layout: auto;\n}\n\nthead {\n  color: white;\n  font-weight: 700;\n  text-align: left;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  padding: 13px 10px !important;\n}\n\nth,\ntd {\n  padding: 13px 10px !important;\n  border: 1px solid #ddd;\n  text-align: left;\n  color: inherit;\n  text-decoration: none;\n}\n\nth {\n  position: sticky;\n  top: 0;\n  background-color: #95a2b1;\n}\n\n.evaluationTable {\n  padding-top: 20px;\n}\n\n.right-content {\n  flex: 1;\n  overflow-y: auto;\n  width: auto;\n  height: 100%;\n}\n\n.table-container {\n  width: 100%;\n  padding: 0px 20px;\n  overflow-x: auto;\n}\n\n.table-wrapper {\n  max-height: 500px;\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.evaluationSubdata-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 250px;\n  table-layout: auto;\n  width: 0% !important;\n}\n\n.menu-header {\n  color: #007bff;\n}\n\n.noDataFound {\n  color: red;\n}\n\n.parent td {\n  background-color: #f2feff !important;\n  font-weight: bold;\n  padding: 13px 10px !important;\n}\n\n.child td {\n  background-color: #eefaff;\n  padding: 13px 10px !important;\n}\n\n.dtr-title {\n  color: #2a62ff;\n  display: inline-block;\n  font-weight: bold;\n  width: 400px !important;\n  padding-left: 52px !important;\n}\n\n.dtr-title:after {\n  content: ' : ';\n}\n\n.dtr-details {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  margin: 0 auto;\n  border-collapse: collapse;\n}\n\n.dtr-details li {\n  list-style-type: none;\n  margin: 10px 0;\n  position: relative;\n  padding-left: calc(20px + var(--level, 0) * 40px);\n}\n/* Table Css Ends Here */\n\n/* Card Css Starts Here */\n.card-box {\n  position: relative;\n  padding: 10px;\n  margin: 15px 0;\n  border-radius: 7px;\n  background-color: #fff;\n  transition: transform 0.4s ease, border 0.4s ease;\n  cursor: pointer;\n  border: 2px solid transparent;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  will-change: transform;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border: 2px solid var(--dynamic-color);\n  color: var(--dynamic-color);\n}\n\n.card-box:hover {\n  transform: scale(0.96);\n  color: #1a1a1a;\n  border: 2px solid var(--dynamic-color);\n}\n\n.card-box .inner {\n  text-align: center;\n}\n\n.card-box .inner h5 {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n  color: var(--dynamic-color);\n}\n\n.card-box .inner p {\n  font-size: 15px;\n  color: #646464;\n  margin: 0;\n}\n\n.card-box.active .inner p {\n  color: white;\n}\n\n.card-box.active .inner h5 {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n  color: white;\n}\n\n.card-box.active {\n  background-color: var(--dynamic-color);\n  color: white;\n  border: 2px solid var(--dynamic-color, #007bff);\n}\n.card-box.reward {\n  background: linear-gradient(135deg, #498bef, #a9b9ef);\n  border: 2px dashed #021d6d;\n  color: black;\n  font-weight: 600;\n}\n.card-box.reward .inner .color-dynamic {\n  color: black;\n}\n\n.custom-grid-wrapper {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.custom-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n@media (max-width: 992px) {\n  .custom-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .custom-grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.active-card {\n  border: 2px solid var(--dynamic-color);\n  background-color: #f0f8ff;\n  box-shadow: 0 0 10px var(--dynamic-color);\n}\n\n/* Card Css Ends Here */\n\n/* Menu Css Starts Here */\n.menu-close-button {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0px;\n}\n\n.menu-toggle-button {\n  width: 35px;\n  height: 35px;\n  background: #4e8ef7;\n  border: 2px solid white;\n  border-radius: 5px;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.menu-toggle-button1 {\n  width: 40px;\n  height: 40px;\n  background: white;\n  border: 2px solid #4e8ef7;\n  border-radius: 5px;\n  color: #4e8ef7;\n  font-size: 20px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.menu-toggle-button:hover {\n  background: #3c7fd9;\n  width: 30px;\n  height: 30px;\n}\n\n.menu-toggle-button1:hover {\n  background: white;\n  width: 35px;\n  height: 35px;\n}\n\n.menu-toggle-button i {\n  padding: 6px;\n}\n\n.menu-toggle-button1 i {\n  padding: 6px;\n}\n\n.menu-tree {\n  width: 3%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  background-color: #f9f9f9;\n}\n\n.menu-tree1 {\n  min-width: 23%;\n  max-width: min-content;\n  overflow-y: auto;\n  position: relative;\n  background-color: #f9f9f9;\n  padding: 10px;\n  border-right: 1px solid #ddd;\n  height: auto;\n  background: linear-gradient(135deg, #498bef, #a9b9ef);\n  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);\n  padding-top: 1px;\n}\n\n/* Menu Css Ends Here */\n\n.right-header {\n  background: #36f;\n  height: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.agentReviewApplndata {\n  display: flex;\n  background: linear-gradient(135deg, #498bef, #a9b9ef);\n  border: 3px solid #f1cf4d;\n  color: white;\n  font-weight: bold;\n  font-size: 1rem;\n  height: 45px;\n  align-items: center;\n  padding: 0 1rem;\n  gap: 2rem;\n  overflow-x: auto;\n\n  .info-pair {\n    display: flex;\n    min-width: fit-content;\n    font-weight: 200;\n\n    label {\n      font-size: 1rem;\n      margin-right: 0.4rem;\n      white-space: nowrap;\n      color: #fff;\n    }\n\n    span {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      color: #f1cf4d;\n    }\n  }\n}\n\n// .backBtn {\n//   color: #36f;\n//   background-color: white;\n//   padding: 6px 12px;\n//   border: 1px solid #36f;\n//   border-radius: 4px;\n//   font-size: 14px;\n//   cursor: pointer;\n// }\n\n// .backBtn:hover {\n//   padding: 6px 12px;\n//   border: none;\n//   border-radius: 4px;\n//   font-size: 14px;\n//   cursor: pointer;\n// }\n\n.backBtn {\n  background: #4e8ef7;\n  border: 2px solid #fff;\n  border-radius: 5px;\n  color: #fff;\n  padding: 6px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.backBtn:hover {\n  background-color: #fff;\n  color: #4e8ef7;\n  border: 2px solid #4e8ef7;\n}\n\n.back-button-wrapper {\n  flex: 1;\n}\n\n/* Ensure full-height layout minus header/footer */\n.card {\n  height: calc(100vh - 75px);\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  flex: 1;\n  display: flex;\n  height: calc(100% - 55px); /* maintain full card height */\n  overflow: hidden;\n}\n\n/* Left menu and right content same height */\n.menu-tree,\n.menu-tree1,\n.right-content {\n  height: calc(100% - 55px);\n  max-height: calc(100% - 55px);\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
